import React, { FC, useCallback } from 'react';
import { useScopedSelector } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StyledButton, StyledT } from './Header.styles';
import { setModificationMode } from '../MessageDetailsPage.actions';
import { MessageDetailsPageState } from '../../../interfaces/MessageDetailsPageState';

export interface HeaderProps {
  mailSubject: string;
  messageSource: string;
}

const Header: FC<HeaderProps> = ({ mailSubject, messageSource }) => {
  const { t } = useTranslation('MessageDetailsPage');
  const dispatch = useDispatch();
  const isModificationMode = useScopedSelector((state: MessageDetailsPageState) => state.modificationMode);
  const canReply: boolean = useScopedSelector((state: MessageDetailsPageState) => state.messageDetails?.canReply);

  const handleAnswerMessage = useCallback(() => {
    dispatch(setModificationMode(true));
  }, [dispatch]);

  return (
    <div>
      <StyledT>{mailSubject ?? ''}</StyledT>
      {messageSource === 'Inbox' && canReply && (
        <StyledButton onClick={handleAnswerMessage} disabled={isModificationMode} data-testid="securedMessagingReplyMessageButton">{t('answerButton')}</StyledButton>
      )}
    </div>
  );
};

export default Header;
